import { createRouter, createWebHistory } from 'vue-router'
const routes = [
  {
    path: '/',
    component: () => import('@/layouts/index.vue'),
    redirect: '/mian_deng',
    children: [
      {
        path: '/login',
        component: () => import('@/views/login/index.vue')
      },
      {
        path: '/no-permission',
        component: () => import('@/views/login/no-permission.vue')
      }
    ]
  },
  {
    path: '/mian_deng',
    component: () => import('@/views/login/miandeng/index.vue')
  },
  {
    path: '/sns_authorize',
    component: () => import('@/views/login/scan-qr/sns_authorize.vue')
  },
  {
    path: '/jumpWithAuthCode',
    component: () => import('@/views/login/miandeng/jump-to-browser-with-auth-code.vue')
  },
  {
    path: '/lark_to_get_auth_code',
    component: () => import('@/views/login/authen/index.vue')
  },
  {
    path: '/lark_login_with_code',
    component: () => import('@/views/login/authen/lark-with-code.vue')
  },
  {
    path: '/logout',
    component: () => import('@/views/logout.vue')
  },
  {
    path: '/reset_password',
    component: () => import('@/views/reset-password/index.vue')
  },
  {
    path: '/reset_password',
    component: () => import('@/views/reset-password/index.vue')
  }
]

const base = import.meta.env.VITE_APP_BASE_URL
const router = createRouter({
  history: createWebHistory(base),
  routes
})

export default router
